import { render, staticRenderFns } from "./inventoryLossDetail.vue?vue&type=template&id=11af3ec4&scoped=true&"
import script from "./inventoryLossDetail.vue?vue&type=script&lang=js&"
export * from "./inventoryLossDetail.vue?vue&type=script&lang=js&"
import style0 from "./inventoryLossDetail.vue?vue&type=style&index=0&id=11af3ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11af3ec4",
  null
  
)

export default component.exports